
export default {
    name: 'IchraBadge',
    props: {
        ichra: { type: Boolean, default: false },
        // The TPA administering the ICHRA, e.g. "BenefitBay"; omitted when unknown.
        ichraTpa: { type: String, default: null },
        // What the pill is attached to, for the tooltip: a client or an employer.
        noun: { type: String, default: 'ICHRA client' },
    },
    computed: {
        label () {
            return this.ichraTpa ? `ICHRA/${this.ichraTpa}` : 'ICHRA'
        },
        tooltip () {
            return this.ichraTpa ? `${this.noun}, administered by ${this.ichraTpa}` : this.noun
        },
    },
}
